module.exports = __webpack_public_path__ + "8e793a5d4d1cd1f6632a3482b612fadb.pdf";